<template>
    <div class="page-about-section">
        <div class="about-desc-column">
            <div class="col-desc" v-html="aboutPage.about_desc_left"></div>
            <div class="col-list">
                <h3>{{ aboutPage.about_desc_right_title }}</h3>
                <div class="check-items">
                    <div class="item" v-for="item in aboutPage.about_desc_right_list">
                        <svgIcon name="check" class="icon-check"/>
                        <strong>{{ item.name }}</strong>
                        <p v-html="item.desc"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="about-section-sales-items">
            <div class="a-sales-items-carousel">
                <swiper :options="swiperOption" ref="aboutSectionSalesCarousel">
                    <swiper-slide v-for="(slide, index) in salesItems" :key="index">
                        <div class="sale-item sale-item-about-page">
                            <saleItem :salesArr="slide" :saleItemIndex="index" :saleItemsParentPage="'about'"></saleItem>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="swiper-controls about-section-controls">
                    <div class="about-section-btn-prev slider-btn btn-wow-effect-hover">
                        <svgIcon name="arrow-left" class="icon-left-arrow"/>
                    </div>
                    <div class="about-section-btn-next slider-btn btn-wow-effect-hover">
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div>
                </div>
                <div class="swiper-pagination about-section-pagination"></div>
            </div>
        </div>
        <div class="about-section-new-sales-items">
            <h3>{{ aboutPage.about_new_projects_title }}</h3>
            <div class="new-sales-items-carousel-container">
                <div class="new-sales-items-filter">
                    <ul>
                        <li v-for="item in filterNames" @click="filterNewSalesItems(item), filterNameActive = item" :class="{active : filterNameActive == item}">{{ item }}</li>
                    </ul>
                </div>
                <div class="items-carousel">
                    <swiper :options="swiperOptionNewSalesItems" ref="swiperNewSalesItems">
                        <swiper-slide v-for="(slide, index) in newSalesItems" :key="index">
                            <div class="promo-pic" :style="'background-image: url(' + slide.project_main_img + ')'">
                                <div class="slide-info">
                                    <strong>{{ slide.name.name }}</strong>
                                </div>
                                <router-link :to="{ name: 'sales-card' , params:{'id' : slide.name.slug}}" class="btn-more btn-wow-effect-hover">
                                    <span v-if="globalLang == ''">Подробнее</span>
                                    <span v-if="globalLang == 'kz/'">Толығырақ</span>
                                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                                </router-link>
                            </div>
                        </swiper-slide>
                    </swiper>

                    <div class="swiper-controls about-new-sales-controls" :class="{'hide' : newSalesItems != null && newSalesItems.length <= 1}">
                        <div class="about-new-sales-btn-prev slider-btn btn-wow-effect-hover">
                            <svgIcon name="arrow-left" class="icon-left-arrow"/>
                        </div>
                        <div class="about-new-sales-btn-next slider-btn btn-wow-effect-hover">
                            <svgIcon name="arrow-right" class="icon-right-arrow"/>
                        </div>
                    </div>
                    <div class="swiper-pagination about-new-sales-pagination" :class="{'hide' : newSalesItems != null && newSalesItems.length <= 1}"></div>
                </div>
                <!-- {{ filterNames }} <br>
                {{ newSalesItems }} -->
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import saleItem from '@/components/sales-page/sale-item.vue'
    export default {
        name: 'about-page-section',
        components: {
            svgIcon,
            saleItem,
        },
        metaInfo() {
            return {
                title: 'Надежный застройщик "DIAL GROUP" - О компании',
                meta: [
                    { name: 'description', content:  'Первичные квартиры комфорт-класса в Алмалинском районе от 24 000 000 тенге. В 10 минутах от MEGA Park. Готовые квартиры в ЖК бизнес-класса в золотом квадрате.'},
                ]
            };
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 2,
                    spaceBetween: 50,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    // autoplay: {
                    //     delay: 3000,
                    //     disableOnInteraction: true,
                    // },
                    navigation: {
                        nextEl: '.about-section-btn-next',
                        prevEl: '.about-section-btn-prev',
                    },
                    breakpoints: {
                        // when window width is <= 900px
                        800: {
                            slidesPerView: 1,
                            spaceBetween: 15
                        },
                        1200: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                    },
                    pagination: {
                        el: '.about-section-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
                swiperOptionNewSalesItems: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.about-new-sales-btn-next',
                        prevEl: '.about-new-sales-btn-prev',
                    },
                    pagination: {
                        el: '.about-new-sales-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
                filterNameActive: null,
                filterNames: null,
                newSalesItems: null,
                newSalesItemsDef: null,
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            salesItems: 'loadSalesItems',
        }),
        methods: {
            BuildNewSalesItemsFilter() {
                var data = this.salesItems;
                if (data != null && data.length > 0) {
                    var filterNames = [];
                    var filterItems = data.filter(function( obj ) {  // фильтруем только новые жк
                        return obj.filter_params.new_dev == true;
                    }); 
                    for (var i=0; i < filterItems.length; i++) { // получаем досутпные сегменты всех новых жк для фильтрации
                        filterNames.push(data[i].filter_params.segment.name);
                    }
                    this.newSalesItemsDef = filterItems;
                    this.filterNames = this.uniqueElementsInArray(filterNames);
                    this.filterNewSalesItems(filterNames[0]);
                    // console.log(filterItems, this.uniqueElementsInArray(filterNames), this.salesItems)
                }
            },
            filterNewSalesItems(key) {
                this.filterNameActive = key;
                var arr = this.newSalesItemsDef;
                var filterItems = arr.filter(function( obj ) {
                    return obj.filter_params.segment.name == key;
                });
                this.newSalesItems = filterItems;
                // console.log(arr, filterItems, this.newSalesItems)
            },
            uniqueElementsInArray(arr) {
                let result = [];
                for (let str of arr) {
                    // console.log(str, 'unique')
                    if (!result.includes(str)) {
                        result.push(str);
                    }
                }
                return result;
            },
        },
        created () {
            
        },
        mounted() {
            this.BuildNewSalesItemsFilter();
            this.$store.watch(
                (state) => state.salesItems,
                (newValue) => {
                    if (newValue) 
                    this.BuildNewSalesItemsFilter();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-section.scss';
    @import '@/styles/components/about-page/respond/about-section-respond.scss';
</style>